var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowFoward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3839 6.0303C13.091 5.7374 13.091 5.2626 13.3839 4.9697C13.6768 4.6768 14.1517 4.6768 14.4445 4.9697L20.2374 10.7626C20.9209 11.446 20.9209 12.554 20.2374 13.2374L14.4445 19.0303C14.1517 19.3232 13.6768 19.3232 13.3839 19.0303C13.091 18.7374 13.091 18.2626 13.3839 17.9697L18.6036 12.75L3.91427 12.75C3.49997 12.75 3.16427 12.4142 3.16427 12C3.16427 11.5858 3.49997 11.25 3.91427 11.25L18.6036 11.25L13.3839 6.0303Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFoward);
export default __webpack_public_path__ + "static/media/arrow-foward.dde3e78b5b7bd56618514010fdf95b9c.svg";
export { ForwardRef as ReactComponent };